<template>
    <div>
        <div id="create-campaign">
            <div class="app-container mb-5" v-show="!$global.loading">
                <div class="page-title mb-3">
                    <span v-if="aspect !== undefined && aspect !== ''">
                        Duplication d'une Campagne Aspect - {{ aspectLabel }} </span>
                    <span v-else>
                      Duplication d'une Campagne de mise à jour
                    </span>
                </div>

                <v-text-field v-model="campaign.name"
                              background-color="white"
                              label="Nom de votre campagne"
                              outlined>
                </v-text-field>

                <v-stepper @change="setCurrentStep" non-linear :value="currentStep">
                    <v-stepper-header>
                        <v-stepper-step editable step="1">
                            Sélection
                        </v-stepper-step>

                        <v-stepper-step editable step="2">
                            Prestataires ({{ emailsValid.length }})
                        </v-stepper-step>

                        <v-stepper-step editable step="3">
                            Informations
                        </v-stepper-step>

                        <v-stepper-step editable step="4">
                            Contenu de l'e-mail
                        </v-stepper-step>

                        <v-stepper-step editable step="5">
                            Options
                        </v-stepper-step>

                        <v-stepper-step editable step="6">
                            Finaliser
                        </v-stepper-step>
                    </v-stepper-header>

                    <v-stepper-items>
                        <v-stepper-content step="1">
                            <filters :aspect="aspect"></filters>
                        </v-stepper-content>

                        <v-stepper-content step="2">
                            <verification></verification>
                        </v-stepper-content>

                        <v-stepper-content step="3">
                            <information v-if="tabulations.length"
                                         :tabulations="tabulations"
                                         :select-all="true"
                                         :aspect="aspect"
                            >
                            </information>
                        </v-stepper-content>

                        <v-stepper-content step="4">
                            <email v-if="providers.length"></email>
                        </v-stepper-content>

                        <v-stepper-content step="5">
                            <options :criterias="criterias" :is-revival="false" :hasSuggestionOption="hasSuggestionOption">
                            </options>
                        </v-stepper-content>

                        <v-stepper-content step="6">
                            <finalize :cmaj-name="campaign.name"
                                      :update-mode="false"
                                      :is-revival="false"
                                      :criterias="criterias"
                                      :aspect="aspect"
                                      :hasSuggestionOption="hasSuggestionOption">
                            </finalize>
                        </v-stepper-content>
                    </v-stepper-items>
                </v-stepper>
            </div>
        </div>
    </div>
</template>

<script>
import Filters from "@/components/campaign/cmaj/stepers/Filters"
import { mapMutations, mapState } from "vuex"
import Verification from "./stepers/Verification"
import Information from "./stepers/Information"
import Email from "./stepers/Email"
import Finalize from "./stepers/Finalize"
import Options from "./stepers/Options"
import { aspectElements } from "../../../static/webform"

export default {
    name: "DuplicateCampaign",
    components: { Finalize, Email, Information, Verification, Filters, Options },
    data() {
        return {
            cmajId: null,
            campaign: { name: null },
            tabulations: [],
            initialCmaj: null,
            criterias: [],
            aspect: "",
            hasSuggestionOption: false,
        }
    },
    methods: {
        ...mapMutations("createCmaj", ["setCurrentStep", "setFirstPartMail", "setLastPartMail", "setSender",
            "resetState", "setSubject", "setSignature", "setMediaSuggestion", "setPeriodsConfig", "setTxtIntro"]),
        getCmaj() {
            this.$global.loading = true

            this.$http.get("auth/campaigns/cmaj/providers/" + this.cmajId).then(res => {
                this.initialCmaj = res.body.data.cmaj

                this.initDefaultName()

                this.setSender(this.initialCmaj.sender)
                this.setSubject(this.initialCmaj.batches[0].email_subject)
                this.setFirstPartMail(this.initialCmaj.batches[0].email_part1)
                this.setLastPartMail(this.initialCmaj.batches[0].email_part2)
                this.setSignature(this.initialCmaj.sender.signature)
                this.setMediaSuggestion(this.initialCmaj.media_suggestion)
                this.setPeriodsConfig(this.initialCmaj.periods_config)

                this.$global.loading = false
            })
        },
        getFields() {
            this.$http.get("auth/campaigns/cmaj/referential/fields/" + this.cmajId).then(res => {
                this.tabulations = res.body.data.tabulations
                this.setTxtIntro(res.body.data.txtIntro)
            })
        },
        initDefaultName() {
            this.campaign.name = this.initialCmaj.name + " (copie)"
        },
        getInternalCriterias() {
            this.$http.get("auth/account/apidae-criterias").then(res => {
                this.criterias = res.body.data.criterias
            })
        },
        setHasSuggestionOption() {
            let option = undefined
            let exist = false

            this.account.current_contracts.forEach(contract => {
                option = contract.contract_offer.options.find(option => option.code === "MEDIA_SUGGESTION")

                if (option !== undefined) {
                    exist = true
                }
            })

            this.hasSuggestionOption = exist
        },
    },
    computed: {
        ...mapState("account", ["senders", 'account']),
        ...mapState("createCmaj", ["currentStep", "emailsValid", "providers"]),
        aspectLabel() {
            if(this.aspect !== undefined && this.aspect !== '') {
                return aspectElements.find(aspect => {
                    return aspect.name === this.aspect
                }).label
            }
        },
    },
    created() {
        let hash = this.$route.params.hash
        this.cmajId = atob(hash)
        this.aspect = this.$route.params.aspect
        this.getCmaj()

        this.resetState()
        this.$store.dispatch("account/fetchContacts")
        this.getFields()
        this.getInternalCriterias()
        this.setHasSuggestionOption()

        this.$store.dispatch("account/loadSenders")

        this.$store.dispatch("account/fetchCategories")
        this.$store.dispatch("account/fetchCommunes")
    },
}
</script>